import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";

export type CancelFileImportDialogType = {
  isOpen: boolean;
  handleClose: () => void;
  handleCancel: () => void;
  isPassthrough?: boolean;
};

const CancelFileImportDialog = ({
  isOpen,
  handleClose,
  handleCancel,
  isPassthrough = false,
}: CancelFileImportDialogType) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      width={"530px"}
      isOpen={isOpen}
      onUserDismiss={handleClose}
      title={
        isPassthrough
          ? l10n.getString("cancel-passthrough-dialog-title")
          : l10n.getString("cancel-payment-dialog-title")
      }
      footer={
        <Row alignItems="center">
          <Row.Item>
            <Button kind="plain" onClick={handleClose}>
              {l10n.getString("label-go-back")}
            </Button>
          </Row.Item>
          <Row.Item shrink>
            <Button onClick={handleCancel}>
              {isPassthrough
                ? l10n.getString("label-cancel-passthrough")
                : l10n.getString("label-cancel-payment")}
            </Button>
          </Row.Item>
        </Row>
      }
    >
      <span className="margin--bottom--xl">
        {isPassthrough
          ? l10n.getString("cancel-passthrough-dialog-content")
          : l10n.getString("cancel-bulk-dialog-content")}
      </span>
    </Dialog>
  );
};

export default CancelFileImportDialog;
